import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateNews(state, { id, data }) {
      state.fund[id] = data;
    },
  },
  actions: {
    updateNews({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('EMNewApi.getNewlist', id)
          .then((json) => {
            commit('updateNews', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
